export default {"src":"/_next/static/media/bg_standart_1.b6f0dcf0.svg","height":191,"width":200,"blurWidth":0,"blurHeight":0};